import { requestToApp } from '@/api/app';
import { pendingBindDevicesStorage } from '@/utils/business';

/**
 * 通知 App 处理订阅的待绑定设备，并清理临时记录。
 */
export const completePendingSubscription = ( subscriptionId: string | undefined ): void => {

    const pendingBindDevices = pendingBindDevicesStorage.getItem( 'pendingBindDevices' );
    if ( !pendingBindDevices?.length ) return;
    requestToApp( 'completeSubscription', {
        subscription: subscriptionId,
        devices: pendingBindDevices
    });
    pendingBindDevicesStorage.removeItem( 'pendingBindDevices' );

};
